import React from 'react';
import { GridLegacy as Grid, Typography } from '@mui/material';

const DATA = {
  CORRIDOR: 'This is a type for CORRIDOR facilities object',
  FLOOR: 'This is a type for FLOOR facilities object',
  ROOM: 'This is a type for ROOM facilities object',
  STAIRWELL: 'This is a type for STAIRWELL facilities object',
};

const Location = ({ attr }) => (
  <div className="leaf location">
    <Typography variant="h5" className="name">
      {attr}
    </Typography>

    <Grid item xs={2}>
      <Typography variant="h6">Description:</Typography>
    </Grid>
    <Grid item xs={8} className="static-attr">
      <Typography>{DATA[attr]}</Typography>
    </Grid>
  </div>
);

export default Location;
